import { z } from 'zod'

export const ResponseInstagramAccountSchema = z.object({
  id: z.number(),
  username: z.string(),
  followers_count: z.number(),
  profile_picture: z.string().url().nullable(),
})
